import { Column } from "react-table";
const ColumnSettings: Array<Column> = [
  {
    Header: "Name",
    accessor: "name"
  },
  {
    Header: "Prefisso",
    accessor: "rolePrefix"
  },
  {
    Header: "API Key",
    accessor: "apiKey"
  },
]; 
export default ColumnSettings;